import React from "react";
import { ArrowUpRight, Building2, Users, Trophy } from "lucide-react";
import { IMAGES, buildWhatsAppLink } from "../constants";

const benefits = [
  { icon: Trophy, title: "Equipos deportivos", desc: "Uniformes y jerseys con escudo, número y nombre." },
  { icon: Building2, title: "Marcas y empresas", desc: "Merchandising, uniformes corporativos y eventos." },
  { icon: Users, title: "Familias y celebraciones", desc: "Bautizos, cumpleaños, paseos, reuniones familiares." },
];

export default function B2B() {
  return (
    <section
      id="b2b"
      data-testid="b2b-section"
      className="relative py-24 sm:py-32 bg-ink text-page overflow-hidden"
    >
      {/* BG image with overlay */}
      <div className="absolute inset-0">
        <img
          src="/bodys/grupo-3.jpeg"
          alt="Equipos vistiendo Vallitas"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ink/95 via-ink/80 to-vino/60" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <div className="text-[11px] uppercase tracking-[0.3em] text-cream font-medium mb-5">
            Para equipos & marcas
          </div>
          <h2
            data-testid="b2b-title"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]"
          >
            Uniformes que <em className="text-cream not-italic">inspiran</em>
            <br />
            a quien los lleva.
          </h2>
          <p className="mt-6 max-w-xl text-base sm:text-lg text-cream leading-relaxed">
            Producimos pedidos por volumen para equipos deportivos, escuelas,
            empresas, eventos y celebraciones. Cotización rápida, calidad
            constante y entrega coordinada.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-4">
            {benefits.map((b) => {
              const Icon = b.icon;
              return (
                <div
                  key={b.title}
                  data-testid={`b2b-benefit-${b.title.toLowerCase().replace(/\s/g, "-")}`}
                  className="rounded-2xl border border-page/15 bg-page/5 backdrop-blur-sm p-5"
                >
                  <Icon className="text-cream mb-3" size={22} />
                  <div className="font-medium text-[15px] text-page">
                    {b.title}
                  </div>
                  <p className="text-xs text-cream mt-1.5 leading-relaxed">
                    {b.desc}
                  </p>
                </div>
              );
            })}
          </div>

          <a
            href={buildWhatsAppLink("Hola, quiero cotizar uniformes para mi equipo / marca.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="b2b-cta"
            className="mt-10 inline-flex items-center gap-2 rounded-full bg-page text-ink px-7 py-4 text-[15px] font-medium hover:bg-cream transition-all hover:-translate-y-1"
          >
            Cotiza para tu equipo
            <ArrowUpRight size={18} />
          </a>
        </div>

        <div className="lg:col-span-5 hidden lg:block">
          <div className="space-y-5">
            <div className="rounded-[2rem] overflow-hidden aspect-[4/3] border border-page/10">
              <img
                src="/bodys/grupo-3.jpeg"
                alt="Equipo deportivo"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="paper-card rounded-2xl p-6 text-ink">
              <div className="label-eyebrow mb-2">Pedido mínimo</div>
              <div className="font-heading text-3xl">Desde 12 unidades</div>
              <p className="text-sm text-[#5C5050] mt-2">
                Descuentos progresivos según volumen. Coordinamos diseño y
                entrega.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
